/**
 * Generate My Month Wizard — DEPRECATED.
 *
 * The full 4-step GMW class used to live here, but the wizard has been
 * unified into the Campaign Wizard. This module now exists solely as an
 * alias so older call sites (home page card, command-palette command)
 * keep working.
 */
import { openCampaignWizard } from './campaignWizard.js';

export function openGenerateMonthWizard() {
    openCampaignWizard();
}
